export class Type {
  public  isMeterExist: boolean;
  public meterNumbers?: string[];
  public premiseId: string;
}

  export class GasRequestStatus {
  public  isBCAFound = false;
  public  isBCAAddedLoad = false;
}
